import { BFormRadio } from './form-radio';
import { BFormRadioGroup } from './form-radio-group';
import { pluginFactory } from '../../utils/plugins';
var FormRadioPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BFormRadio: BFormRadio,
    BRadio: BFormRadio,
    BFormRadioGroup: BFormRadioGroup,
    BRadioGroup: BFormRadioGroup
  }
});
export { FormRadioPlugin, BFormRadio, BFormRadioGroup };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-radio/index.js
// module id = DQqX
// module chunks = 22